"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useViews = void 0;
const core_1 = require("../../core");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const store_1 = require("../../store");
/**
 * Get the bound datasheet view and handle returning only one view in the mirror.
 * @param datasheetId
 */
const useViews = (datasheetId) => {
    const views = (0, react_redux_1.useSelector)(state => {
        var _a;
        const sourceId = (_a = state.widget) === null || _a === void 0 ? void 0 : _a.snapshot.sourceId;
        const datasheet = (0, store_1.getWidgetDatasheet)(state, datasheetId);
        if (!datasheet) {
            return [];
        }
        const views = datasheet.snapshot.meta.views;
        if (sourceId === null || sourceId === void 0 ? void 0 : sourceId.startsWith('mir')) {
            const sourceInfo = core_1.Selectors.getMirrorSourceInfo(state, sourceId);
            if (sourceInfo) {
                const viewData = views.find(viewData => viewData.id === sourceInfo.viewId);
                return viewData ? [viewData] : [];
            }
        }
        return views;
    }, react_redux_1.shallowEqual);
    return (0, react_1.useMemo)(() => views, [views]);
};
exports.useViews = useViews;
